/**
 * Único selector global de sucursal activa — montado arriba del nav en
 * ambos sidebars (`DashboardSidebar.tsx`, `ds/Sidebar.tsx`), nunca duplicado
 * por pantalla. Cambia el `activeLocationId` de `LocationContext`, que el
 * resto del admin puede leer vía `useWorkspaceLocationId()`.
 *
 * Sin opción "Todas las sucursales": tras el gate obligatorio
 * (AppLocationGate), la sucursal activa es siempre una concreta — "todas"
 * sobrevive solo como lente de reporting en /app/metrics y /app/dashboard,
 * no como algo elegible acá.
 */
import { Building2, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLocationContextSafe } from "@/lib/location-context";

export function LocationContextSwitcher() {
  const ctx = useLocationContextSafe();
  if (!ctx || ctx.loading || !ctx.isMultiLocation) return null;

  const label = ctx.activeLocation?.name ?? "Elegir sucursal";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex w-full items-center gap-2 rounded-lg border border-border/60 bg-card px-3 py-2 text-sm font-medium text-foreground hover:bg-muted/50"
        >
          <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="min-w-0 flex-1 truncate text-left">{label}</span>
          <ChevronDown className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {ctx.locations.map((l) => (
          <DropdownMenuItem key={l.id} onClick={() => ctx.setActiveLocationId(l.id)}>
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
